import 'slick-carousel';
import fancybox from '@fancyapps/fancybox';

import '../cw.js';
import '../cw.basket.js';
import '../regUpdateBasket';
import '../components/addToCompare';
import '../input.js';
import '../common';
import '../layout';
import '../product';
import '../coockies'

import ProductViewSwitcher from "../components/ProductViewSwitcher";
import ChooseSize from "../components/ChooseSize";
// import CustomedSelect from '../components/CustomedSelect';
// import ShowMoreImages from '../components/ShowMoreImages'; - используется для b2c вида страницы товара (пока отключен)


window.$ = jquery;
window.CW = CW;


document.addEventListener('DONContentLoaded', function(){
    // переключение вида страницы товара b2b -> b2c - незакомментированным остался функционал
    // смены вида b2c страницы товара на b2b для адаптивной версии (при ресайзе и загрузке), так как на адаптиве у них одинаковый вид
    const switchers = document.querySelectorAll('.js-product-row');
    if(switchers.length > 0) {
        switchers.forEach(switcher => {
            new ProductViewSwitcher({
                selector: switcher
            })
        })
    }

    // выбор размера на странице b2c товара

    const selectSizeBlocks = document.querySelectorAll('.js-select-size-content');
    if(selectSizeBlocks.length > 0) {
        selectSizeBlocks.forEach(block => {
            new ChooseSize({
                selector: block
            })
        })
    }

    // селект с выбором размера для b2c товара
    /*
    const sizeSelects = document.querySelectorAll('.js-select-size');
    if(sizeSelects.length > 0) {
        sizeSelects.forEach(select => {
            new CustomedSelect({
                selector: select
            })
        })
    }
     */


    // показать больше (четырех изображений) на b2c странице товара - временно отключен, так как b2c-вид страницы товара не используется
    /*
    const showMoreImgs = document.querySelectorAll('.js-show-more-img');
    if(showMoreImgs.length > 0) {
        showMoreImgs.forEach(img => {
            new ShowMoreImages({
                selector: img
            })
        })
    }
     */

    //expanding block - временно не используется
    /*
    $('.expand-container .show-more-btn').on('click', function () {
        let $parent = $(this).closest('.expand-container');
        let $hideBlock = $parent.find('.hidden-block');

        $hideBlock.addClass('show-block');
        $(this).hide();
    })
    */

})

//подсчет количества столбцов в таблице ТП для навешивания доп класса для стилей
const tableWrapper = document.querySelector('.tab-content-wr');

if(tableWrapper) {
    const scuTable = tableWrapper.querySelector('.size-table');
    const firstTableRow = scuTable.querySelector('tr');
    const columnsQuantity = firstTableRow.querySelectorAll('.td').length;
    scuTable.classList.add(`columns-${columnsQuantity}`);

}



